import state from './inbox.store'
import mutations from './inbox.mutations'
import actions from './inbox.actions'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
